export default "__VITE_ASSET__bc960fbb__"